const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {ErrorBoundary} = require("react-error-boundary");
const ReactPlayer = require("react-player").default;

const ErrorUtil = require("../../shared/ErrorUtil");

module.exports = createReactClass({
	displayName: "ReactPlayerWrapper",

	propTypes: {
		defaultRef: PT.func,
		onCatchPlayerError: PT.func,
	},

	render: function() {
		const props = _.omit(this.props, ["defaultRef", "onCatchPlayerError"]);
		props.ref = this.props.defaultRef;
		return (
			<ErrorBoundary
				onError={(error, info) => {
					ErrorUtil.log("E_REACT_CRASH", error, info);
					this.props.onCatchPlayerError();
				}}
				fallbackRender={() => null}
			>
				<ReactPlayer {...props} />
			</ErrorBoundary>
		);
	},
});
